import { Platform } from "react-native";

import type { PlatformName } from "../types";

/** where the app runs, read once: React Native's OS, and Electron's preload flag on web */
export function detectPlatform(): PlatformName {
  if (Platform.OS === "android" || Platform.OS === "ios") return Platform.OS;
  const host = typeof window !== "undefined" ? (window as { electronAPI?: { isElectron?: boolean } }) : undefined;
  return host?.electronAPI?.isElectron ? "electron" : "web";
}
